import { render } from "./ConfigurationRenewCart.vue?vue&type=template&id=0c67a5ce"
import script from "./ConfigurationRenewCart.vue?vue&type=script&lang=js"
export * from "./ConfigurationRenewCart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__